import 'twin.macro';
import 'styled-components/macro';

export interface FavoritesToggleProps {
  isInFavorites: boolean;
  onClick: () => void;
}

export const FavoritesToggle = ({ isInFavorites, onClick }: FavoritesToggleProps) => {
  return (
    <div
      tw="inline-block display-4 cursor-pointer opacity-50 hover:opacity-100"
      title={isInFavorites ? 'Remove from favorites' : 'Add to favorites'}
      onClick={() => onClick()}
    >
      {isInFavorites ? '⭐' : '☆'}
    </div>
  );
};
